const tintColor = "#2f95dc";

export const theme = {
  black: "#191716",
  red: "#E80334",
  softRed: "#d31740",
};

const colors = {
  primary: "#E80334",
  secondary: "#191716",
  blue: "#0222FF",
  grey: "#F2F2F2",
  textSecondary: "#535353",
  dark: "#263239",
  tintColor,
  tabIconDefault: "#ccc",
  tabIconSelected: tintColor,
  tabBar: "#fefefe",
  errorText: "red",
  warningBackground: "#EAEB5E",
  warningText: "#666804",
  noticeBackground: tintColor,
  noticeText: "#fff",
};

export const defaultColors = ["#003f5c", "#d45087", "#ff7c43"];
export const beamwidthColors = [
  "#003f5c",
  "#665191",
  "#d45087",
  "#f95d91",
  "#ff7c43",
  "#ffa600",
];

export default colors;
